import { plainToInstance, instanceToPlain, ClassConstructor, ClassTransformOptions } from 'class-transformer'

export const transformObject = <T>(transformer: ClassConstructor<any>, obj: Record<string, any>, options: ClassTransformOptions = {}): T => {
  const transformOptions = { excludeExtraneousValues: true, exposeDefaultValues: false, ...options }
  const instance = plainToInstance(transformer, obj, transformOptions)
  return instanceToPlain(instance, transformOptions) as T
}
